import {Translation} from '@/i18n/locales/type.ts';

const ko: Translation = {
  home: {
    firstVisit: '예약 없이 첫 방문이에요',
    returningVisitor: '전화번호 또는 이메일 중 하나를 입력해주세요.',
    error_message: {
      invalid_token: '인터넷 환경이 원활하지 않습니다.',
      search: '검색 중 오류가 발생했습니다.',
      checkin:
        '접수 중 오류가 발생했습니다. 계속해서 문제가 발생한다면 데스크에 문의해주세요.',
    },
    dialog_message: {
      reservation: {
        checked_in: '예약이 확인되었습니다. 접수가 완료되었습니다.',
        no_customer:
          '고객 정보가 확인되지 않았습니다.\n전화번호나 이메일을 다시 확인해주세요.',
      },
      walkin: {
        checked_in:
          '접수가 완료되었습니다. 잠시만 기다려 주시면 순서대로 안내해 드리겠습니다.',
        no_customer_title: '고객 정보를 찾지 못했어요.',
        no_customer_description: '처음 방문이신가요?',
        start_first_visit: '처음 방문 접수하기',
        no_booking_title: '{{name}}님, 당일 접수로 도와드릴게요.',
        no_booking_description:
          '당일 접수로 상담과 시술을 도와드릴게요.\n현장 상황에 따라 대기 시간이 길어지거나 일부 시술이 어려울 수 있어요.',
        start_checkin: '접수하기',
      },
      no_booking: {
        title: '예약 정보를 찾을 수 없습니다',
        description:
          '세심한 진료와 충분한 상담시간 마련을 위해\n사전 예약제로 운영되고 있습니다.\n예약을 하셨다면 데스크에 문의해 주시기 바랍니다.',
      },
      invalid_building: {
        title:
          '병원 정보가 올바르지 않습니다. 접수하시려는 병원이 "서울 강남 뮤즈의원 본관 2층"이 아니라면 데스크에서 올바른 접수 사이트 주소를 안내받으세요.',
      },
      common: {
        confirm: '확인',
        cancel: '취소',
      },
      confirm: {
        title: '{{name}}님 안녕하세요!',
        description: '바로 접수하시겠습니까?',
        confirm: '예, 접수할게요',
        cancel: '아니오',
      },
    },
    form: {
      title: {
        name: '예약자 성함',
        phone: '전화번호',
        email: '이메일',
      },
      placeholder: {
        name: '성함을 입력해주세요',
        phone: '전화번호를 입력해주세요',
        email: '이메일을 입력해주세요',
      },
      description: '전화번호를 입력하면 이메일은 생략할 수 있습니다.',
      button: {
        title: '접수하기',
        loading: '검색 중...',
      },
      birth: {
        title: '고객 정보 확인을 위해 생년월일을 입력해 주세요.',
        year: '년도',
        month: '월',
        day: '일',
      },
    },
    customer_info: {
      title: '고객 정보',
      name: '이름',
      phone: '전화번호',
      email: '이메일',
      button_title: '접수 진행하기',
    },
    language_select: {
      button_title: '🌐 Change Language / 언어',
    },
  },
  common: {
    or: '또는',
  },
  createChart: {
    title: '신규 차트 등록',
    error_message: {
      invalid_form: '모든 정보를 입력해주세요.',
      checkin: '접수 처리 중 오류가 발생했습니다.',
    },
    dialog_message: {
      complete: {
        title:
          '차트 생성 및 접수가 완료되었습니다.\n당일 방문 고객은 대기가 있을 수 있으니 양해 부탁드립니다.',
        button_title: '확인',
      },
    },
    form: {
      name: {
        title: '예약자 성함',
        placeholder: '예약자 성함을 입력해주세요.',
        passport_notice:
          '정확한 예약과 원활한 서비스 제공을 위해, 한국 국적이 아닌 고객님께서는 여권에 기재된 영문 성함을 입력해 주시기를 부탁드립니다.',
      },
      phone: {
        title: '전화번호',
        placeholder: '전화번호를 입력해주세요.',
      },
      email: {
        title: '이메일',
        placeholder: '이메일을 입력해주세요.',
      },
      birth: {
        title: '생년월일',
        year: '년도',
        month: '월',
        day: '일',
      },
      gender: {
        title: '성별',
        male: '남성',
        female: '여성',
      },
      button: {
        title: '차트 생성 및 접수',
        loading: '차트 생성 중...',
      },
    },
  },
};

export default ko;
